module.exports = __webpack_public_path__ + "static/img/face12.711b1a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face12.jpg
// module id = ZrvI
// module chunks = 1